import {
	IconButton,
	Paper,
	Switch,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { EditableTimeCell } from "./EditableTimeCell";
import {
	DAYS_ORDER,
	ERROR_BG,
	headerCellSx,
	TelehealthSchedule,
	TelehealthType
} from "./types";

interface LocalHoursTableProps {
	clinicId: number;
	schedules: TelehealthSchedule[];
	onScheduleChange: (
		schedule: TelehealthSchedule,
		field: "startTime" | "endTime" | "active",
		value: string
	) => void;
	onRemoveSchedule: (id: number) => void;
	invalidScheduleDays: Set<string>;
	validationMessage: string | null;
	localOverlapDays: Set<string>;
}

export const LocalHoursTable = ({
	clinicId,
	schedules,
	onScheduleChange,
	onRemoveSchedule,
	invalidScheduleDays,
	validationMessage,
	localOverlapDays
}: LocalHoursTableProps) => {
	// useEffect(() => {
	// 	console.info("LocalHoursTable schedules", schedules);
	// }, [schedules]);

	return (
		<>
			<TableContainer
				component={Paper}
				variant="outlined"
				sx={{ maxWidth: 560 }}
			>
				<Table size="small">
					<TableHead>
						<TableRow sx={{ bgcolor: "#f5f7fa" }}>
							<TableCell sx={headerCellSx}>Day</TableCell>
							<TableCell sx={headerCellSx}>From</TableCell>
							<TableCell sx={headerCellSx}>To</TableCell>
							<TableCell sx={headerCellSx}>Active</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{DAYS_ORDER.map((day) => {
							const schedule = schedules.find((s) => s.dayOfWeek === day) ?? {
								id: 0,
								clinicId,
								dayOfWeek: day,
								startTime: "",
								endTime: "",
								telehealthType: TelehealthType.Local,
								active: false
							};

							const conflict = localOverlapDays.has(schedule?.dayOfWeek ?? "");
							const hasValidationError = invalidScheduleDays.has(
								schedule.dayOfWeek
							);

							return (
								<TableRow
									key={schedule.dayOfWeek}
									hover={!conflict && !hasValidationError}
									sx={
										conflict || hasValidationError ? { bgcolor: ERROR_BG } : {}
									}
								>
									<TableCell>{schedule.dayOfWeek}</TableCell>
									<EditableTimeCell
										value={schedule.startTime}
										onChange={(v) => onScheduleChange(schedule, "startTime", v)}
									/>
									<EditableTimeCell
										value={schedule.endTime}
										onChange={(v) => onScheduleChange(schedule, "endTime", v)}
										endAdornment={
											<IconButton
												size="small"
												onClick={() => onRemoveSchedule(schedule.id)}
												sx={{
													p: 0.25,
													visibility:
														schedule.id > 0 ||
														schedule.startTime !== "" ||
														schedule.endTime !== ""
															? "visible"
															: "hidden"
												}}
											>
												<DeleteOutlineIcon fontSize="small" />
											</IconButton>
										}
									/>

									<TableCell>
										<Switch
											size="small"
											checked={schedule.active}
											onChange={(e) =>
												onScheduleChange(
													schedule,
													"active",
													e.target.checked.toString()
												)
											}
										/>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
			{validationMessage && (
				<Typography color="error" mt={1} fontSize="0.95rem">
					{validationMessage}
				</Typography>
			)}
		</>
	);
};
